import { takeEvery, call, put } from 'redux-saga/effects';
import { BudgetActions } from '../actions';
import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { push, replace } from 'react-router-redux';
import queryString from 'qs';

const budgetUrl = '/api/budgets';

export function* watchGetAllBudgets() {
	yield takeEvery(BudgetActions.GetAllBudgetsAction.Request, getAllBudgets);
}
function* getAllBudgets(action) {
	let { page, size, isActual } = action.payload;
	try {
		const budgets = yield call(getAllBudgetsRequest, {page, size, isActual});
		yield put({
			type: BudgetActions.GetAllBudgetsAction.Success,
			payload: budgets
		});
		let searchTermFilter = action.payload
			? queryString.stringify(action.payload, { skipNulls: true, addQueryPrefix: true })
			: '';
		yield put(replace(`${window.location.pathname}${searchTermFilter}`));
	} catch (e) {
		yield put({ type: BudgetActions.GetAllBudgetsAction.Failure });
		toastr.error('Pobieranie budżetów', 'Wystąpił niespodziewany błąd podczas pobierania budżetów');
	}
}
export function* watchGetArchiveBudgets() {
	yield takeEvery(BudgetActions.GetArchiveBudgetsAction.Request, getArchiveBudgets);
}

function* getArchiveBudgets(action) {
	let { archiveListPage: page, archiveListSize: size, isActual } = action.payload;
	try {
		const budgets = yield call(getAllBudgetsRequest, {page, size, isActual});

		yield put({
			type: BudgetActions.GetArchiveBudgetsAction.Success,
			payload: budgets
		});
		let searchTermFilter = action.payload
			? queryString.stringify(action.payload, { skipNulls: true, addQueryPrefix: true })
			: '';
		yield put(replace(`${window.location.pathname}${searchTermFilter}`));
	} catch (e) {
		yield put({ type: BudgetActions.GetArchiveBudgetsAction.Failure });
		toastr.error('Pobieranie budżetów', 'Wystąpił niespodziewany błąd podczas pobierania budżetów');
	}
}
function getAllBudgetsRequest(filter) {
	let query = queryString.stringify(filter, { skipNulls: true, addQueryPrefix: true });
	return axios.get(`${budgetUrl}${query}`).then((response) => response.data).catch((err) => {
		throw err;
	});
}

export function* watchGetBudgetResults() {
	yield takeEvery(BudgetActions.GetBudgetResultsAction.Request, getBudgetResults);
}

function* getBudgetResults(action) {
	try {
		let results = yield call(getBudgetResultsRequest, action.payload);
		yield put({
			type: BudgetActions.GetBudgetResultsAction.Success,
			payload: results
		});
	} catch (err) {
		toastr.error('Pobieranie wyników budżetu', 'Wystąpił nieoczekiwany błąd podczas pobierania wyników budżetu');
		yield put({
			type: BudgetActions.GetBudgetResultsAction.Failure
		});
	}
}

function getBudgetResultsRequest(budgetId) {
	return axios.get(`${budgetUrl}/${budgetId}/results`).then((response) => response.data).catch((err) => {
		throw err;
	});
}
